import router, {get404Router, resetRouter} from "./router";
import {setDocumentTitle} from "@/utils/domUtil";
import {getSsoAuthUrl} from "@/api/sso";
import {getUrlParam} from "@/utils/util";
import {reportAppAccess, ACCESS_TYPE} from "@/api/appAccessLog";
import store from "@/store";
import storage from "store";
import {ACCESS_TOKEN, TENANT} from "@/store/mutation-types";

router.beforeEach(async (to, from, next) => {
    to.meta && typeof to.meta.title !== "undefined" && setDocumentTitle(`${to.meta.title}`);

    const token = storage.get(ACCESS_TOKEN);
    const ticket = to.query.ticket;
    const tenant = getUrlParam("tenant");
    if (tenant) {
        storage.set(TENANT, tenant)
    }
    // 请求带有 redirect 重定向时，登录自动重定向到该地址
    const redirect = decodeURIComponent(from.query.redirect || to.path);
    //未登录
    if (ticket) {
        const ticketLogin = await store.dispatch("LoginByTicket", ticket);
        if(ticketLogin.success){
            next({ path: redirect, replace: true });
        }else{
            next()
        }
    } else if (token) {
        if (store.getters.name) {
            // 上报菜单点击访问日志（非根路径）
            if (to.path !== "/" && to.meta && to.meta.title) {
                reportAppAccess({
                    appName: to.meta.appName || "",
                    menuName: to.meta.title,
                    menuPath: to.path,
                    accessType: ACCESS_TYPE.MENU_CLICK,
                }).catch(() => {});
            }
            const isAdmin = store.getters.userInfo.isAdmin || store.getters.userInfo.isPlatformAdmin
            const requiresAdmin = to.path.startsWith('/admin')
            if (requiresAdmin && !isAdmin) {
                next({ path: '/exception/403', replace: true })
                return
            }
            if (to.meta?.type === "app") {
                const tabKey = to.query.tabKey
                console.log('tabKey', tabKey)
                if (tabKey) {
                    // store.getters.currentTab
                    console.log('store.getters.tabs', store.getters.tabs.tabs)
                    console.log('to.meta', to.meta)
                    const tabs = store.getters.tabs.tabs
                    const filterTab = tabs.find(tab => tab.key === tabKey)
                    if(filterTab){
                        store.dispatch("ActiveTab", tabKey).then(() => {
                            store.dispatch("initWebSocket", store.getters.info).then(() => next())
                        })
                    }else{
                        store.dispatch("AddTab", {
                            name: to.meta.title,
                            code: to.name,
                            url: to.meta.url,
                            icon: to.meta.icon
                        }).then(() => {
                            store.dispatch("initWebSocket", store.getters.info).then(() => {
                                next();
                            });
                        });
                    }
                } else {
                    store.dispatch("AddTab", {
                        name: to.meta.title,
                        code: to.name,
                        url: to.meta.url,
                        icon: to.meta.icon
                    }).then(() => {
                        store.dispatch("initWebSocket", store.getters.info).then(() => {
                            next();
                        });
                    });
                }
            } else if (to.meta?.type === "navigation") {
                store.dispatch("AddNavigationIframe", {
                    name: to.meta.title,
                    code: to.name,
                    url: to.meta.url,
                    icon: to.meta.icon
                }).then(() => {
                    store.dispatch("initWebSocket", store.getters.info).then(() => {
                        next();
                    });
                });
            } else {
                store.dispatch("initWebSocket", store.getters.info).then(() => {
                    next();
                });
            }
        } else {
            // 根据用户权限信息生成可访问的路由表
            store.dispatch("GetInfo").then(() => {
                resetRouter();
                router.addRoute(get404Router());
                store.dispatch("GetAppRouter", router).then((data) => {
                    router.addRoute(data);
                    if (to.path === redirect) {
                        // set the replace: true so the navigation will not leave a history record
                        next({ ...to, replace: true });
                    } else {
                        // 跳转到目的路由
                        next({ path: redirect });
                    }
                });
                store.dispatch("GetNavigationRouter", router).then((data) => {
                    console.log('GetNavigationRouter', data)
                    router.addRoute(data);
                    if (to.path === redirect) {
                        // set the replace: true so the navigation will not leave a history record
                        next({ ...to, replace: true });
                    } else {
                        // 跳转到目的路由
                        next({ path: redirect });
                    }
                });
                //获取登录用户详情
                store.dispatch("GetPlatFormConfig")
            }).finally(() => {
                // next()
            });
        }
    } else {
        if (to.name === 'serviceHall') {
            next()
        } else {
            const param = {
                redirectUrl: location.href,
            };
            getSsoAuthUrl(param).then((res) => {
                if (res.success) {
                    console.log('getSsoAuthUrl', res.data)
                    location.href = res.data;
                }
            });
        }
    }
});

router.afterEach(() => {
});
